module.exports = __webpack_public_path__ + "static/neon-2a5c4258e984c58b5eac910a5d807939.png";